// src/components/Icon.js
import React from "react"
import { useTheme } from "context/AntdThemeContext"
import { DSIcon } from "./DSIcon"
import { FEATHER_ICONS } from "./featherIcons"
import { colors } from "themes/variables"

const warnedNames = new Set()

export const Icon = ({ type = "feather", name = "", height = 24, width = 24, strokeWidth = 1.5, color, ...props }) => {
  const isFeatherIcon = type === "feather" && name in FEATHER_ICONS
  const { isSportsman } = useTheme()

  // Feather names are PascalCase, DSIcon names lowercase: warn (dev only, once per name) when a
  // Feather icon is used without being added to featherIcons.js, since it would render nothing
  if (process.env.NODE_ENV !== "production" && type === "feather" && !isFeatherIcon && /^[A-Z]/.test(name) && !warnedNames.has(name)) {
    warnedNames.add(name)
    console.warn(`Icon: "${name}" is not in FEATHER_ICONS. Add it to src/ui/Icon/featherIcons.js.`)
  }

  if (color === undefined) {
    color = isSportsman ? colors.sportsmanBrand : colors.sportswomanBrand
  }

  if (isFeatherIcon) {
    const FeatherIconComponent = FEATHER_ICONS[name]
    return <FeatherIconComponent height={height} width={width} color={color} strokeWidth={strokeWidth} {...props} />
  }

  return <DSIcon name={name} height={height} width={width} fill={color} {...props} />
}
